// Converte pendências de validação da Meta e erros locais em itens do modal "Revise o Flow".
// As descrições da Meta chegam em inglês técnico; a interface mostra uma frase humana em
// português, a tela/linha apontada e mantém o texto original apenas como detalhe recolhido.

const META_ISSUE_RULES = [
  { code: 'TERMINAL', pattern: /TERMINAL/ },
  { code: 'ROUTING', pattern: /ROUTING|NAVIGAT|NEXT_SCREEN|UNREACHABLE/ },
  { code: 'DUPLICATE', pattern: /DUPLICAT|UNIQUE/ },
  { code: 'MISSING', pattern: /MISSING|REQUIRED/ },
  {
    code: 'UNKNOWN_PROPERTY',
    pattern: /UNKNOWN|UNEXPECTED|INVALID_PROPERTY_KEY|NOT_ALLOWED/,
  },
  { code: 'LIMIT', pattern: /LENGTH|LIMIT|TOO_LONG|TOO_MANY|MAX|EXCEED/ },
  { code: 'INVALID_TYPE', pattern: /TYPE/ },
  { code: 'INVALID_VALUE', pattern: /INVALID|VALUE|ENUM|FORMAT/ },
];

const normalize = value =>
  String(value || '')
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_');

export const metaIssueCode = error => {
  const code = normalize(error?.error);
  const text = normalize(`${error?.error_type || ''} ${error?.message || ''}`);
  const rule =
    META_ISSUE_RULES.find(({ pattern }) => pattern.test(code)) ||
    META_ISSUE_RULES.find(({ pattern }) => pattern.test(text));
  return rule ? rule.code : 'GENERIC';
};

const screenFromPointers = error => {
  const paths = [
    ...(Array.isArray(error?.pointers) ? error.pointers : []).map(
      pointer => pointer?.path
    ),
    error?.message,
  ];
  const match = paths
    .map(path => String(path || '').match(/screens\[(\d+)\]/))
    .find(Boolean);
  return match ? Number(match[1]) + 1 : null;
};

// `t` é a função de tradução do vue-i18n.
export const metaIssueItems = (errors, t) =>
  (Array.isArray(errors) ? errors : []).map(error => {
    const screen = screenFromPointers(error);
    const location = [
      screen ? t('WHATSAPP_FLOWS.META_ERRORS.SCREEN', { screen }) : '',
      error?.line_start
        ? t('WHATSAPP_FLOWS.META_ERRORS.LOCATION', {
            line: error.line_start,
            column: error.column_start || 1,
          })
        : '',
    ]
      .filter(Boolean)
      .join(' · ');
    return {
      message: t(`WHATSAPP_FLOWS.META_ERRORS.CODES.${metaIssueCode(error)}`),
      location,
      detail: String(error?.message || error?.error || '').slice(0, 500),
    };
  });

// Chave do campo destacado para cada erro do construtor visual (flowBuilder.validateBuilder).
export const builderIssueField = error => {
  const screen = `s${(error.screen || 1) - 1}`;
  const field = `${screen}.f${(error.field || 1) - 1}`;
  const keys = {
    SCREEN_TITLE: `${screen}.title`,
    SCREEN_HEADING: `${screen}.heading`,
    SCREEN_BODY: `${screen}.body`,
    SCREEN_EMPTY: `${screen}.body`,
    SCREEN_FOOTER: `${screen}.footer`,
    FIELD_TYPE: `${field}.label`,
    FIELD_LABEL: `${field}.label`,
    FIELD_NAME: `${field}.label`,
    FIELD_HELPER: `${field}.helper`,
    FIELD_OPTIONS: `${field}.options`,
  };
  return keys[error.code] || null;
};

// Coloca o foco no primeiro controle do campo marcado com data-flow-field.
export const focusFlowField = key => {
  if (!key || typeof document === 'undefined') return false;
  const container = document.querySelector(`[data-flow-field="${key}"]`);
  if (!container) return false;
  const target = container.matches('input, textarea, select, button')
    ? container
    : container.querySelector('input, textarea, select, button');
  if (!target) return false;
  target.scrollIntoView?.({ block: 'center' });
  target.focus({ preventScroll: true });
  return true;
};
